<template>
    <div v-if="lines.length == 0">
        -
    </div>
    <div v-for="(line, index) in lines"
         v-else
         :key="`text-line-${index}`"
         :class="className">
        <display-text-line :text="line" />
    </div>
</template>

<script setup>
    import { computed, defineProps } from 'vue';
    import DisplayTextLine from './DisplayTextLine.vue';
    import { escapeHtml } from '../js/HTMLUtilities.js';

    const props = defineProps({
        text: {
            type: String,
            default: null
        },
        className: {
            type: String,
            default: null
        }
    });

    const lines = computed(() => calcLines(props.text));

    function calcLines(textBlock) {
        if (textBlock) {
            return escapeHtml(textBlock).split(/\r?\n/);
        } else {
            return [];
        }
    }
</script>